import styled from 'styled-components';

const FlagImage = styled.img`
  width: 28px;
  height: 20px;
`;

export default FlagImage;
